import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { MateriaService } from '../../../services/materia.service';
import { TemaService } from '../../../services/tema.service';

@Component({
  selector: 'app-artigos-por-data',
  templateUrl: './artigos-por-data.component.html',
  styleUrls: ['./artigos-por-data.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArtigosPorDataComponent implements OnInit {
  materias: any;
  temaNome: string;
  ano: number;
  mes: number;
  mesStr: string;
  @ViewChild('masonryGrid') masonryGridElem!: ElementRef<HTMLDivElement>;
  private msnry!: Masonry; // Store Masonry instance
  constructor(
    private route: ActivatedRoute,
    private materiaService: MateriaService,
    private temaService: TemaService,
    private _location: Location
  ) {}

  ngOnInit() {
    this.ano = Number(this.route.snapshot.paramMap.get('ano'));
    this.mes = Number(this.route.snapshot.paramMap.get('mes'));
    let temaId = Number(this.route.snapshot.paramMap.get('temaId'));
    this.temaService.getById(temaId).subscribe((res) => {
      this.temaNome = res.nome;
    });
    this.materiaService
      .getByAnoMesTemaId(this.ano, this.mes, temaId)
      .subscribe((res) => {
        this.materias = res;
        this.initMasonry();
      });
  }

    initMasonry(): void {
    if (this.masonryGridElem && this.masonryGridElem.nativeElement && this.materias.length > 0) {
      imagesLoaded(this.masonryGridElem.nativeElement, () => {
        if (this.msnry) { // If Masonry instance already exists, just relayout
          this.msnry.reloadItems();
          this.msnry.layout();
        } else { // Otherwise, create a new instance
          this.msnry = new Masonry(this.masonryGridElem.nativeElement, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer', // Use .grid-sizer for column width
            percentPosition: true,
            gutter: 0, // Adjust this based on your .grid-item padding.
          });
        }
      });
    }
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

    onImageLoad(): void {
    if (this.msnry) {
      // Use a small timeout to ensure the image dimensions are fully updated in the DOM
      // before Masonry tries to re-layout. This can sometimes be necessary.
      setTimeout(() => {
        this.msnry.layout();
      }, 100);
    }
  }

  getMesStr() {
    switch (this.mes) {
      case 1:
        return 'Janeiro';
      case 2:
        return 'Fevereiro';
      case 3:
        return 'Março';
      case 4:
        return 'Abril';
      case 5:
        return 'Maio';
      case 6:
        return 'Junho';
      case 7:
        return 'Julho';
      case 8:
        return 'Agosto';
      case 9:
        return 'Setembro';
      case 10:
        return 'Outubro';
      case 11:
        return 'Novembro';
      case 12:
        return 'Dezembro';
      default:
        return 'Loading...';
    }
  }

  backClicked() {
    this._location.back();
  }
}
